<ng-template #btnContent>
  <div class="flex flex-row items-center justify-center gap-2">
    @if (loading()) {
      <i class="fa fa-spinner fa-spin"></i>
    } @else {
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 21 21">
        <rect x="1" y="1" width="9" height="9" fill="#f25022" />
        <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
        <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
        <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
      </svg>
    }
    <span class="w-44">{{ 'Accedi con Microsoft' | siaTranslate }}</span>
  </div>
</ng-template>

@if (variant() === 'stroked-button') {
  <button mat-stroked-button [disabled]="isDisabled()" (click)="loginPopup()" class="flex w-full" [class.dark-theme]="theme() === 'dark'">
    <ng-container [ngTemplateOutlet]="btnContent" />
  </button>
} @else {
  <button mat-button [disabled]="isDisabled()" (click)="loginPopup()" class="flex w-full primary" [class.dark-theme]="theme() === 'dark'">
    <ng-container [ngTemplateOutlet]="btnContent" />
  </button>
}
